import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import { PeriodDataDto, RetractTimesheetDto } from '../../../api/generated/v2/generated/data-contracts';
import { USER_PERIOD_BY_DATE } from '../../../constants/queryKeys';
import { useGridStore } from '../state';

export const useRetractTimesheet = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (dto: RetractTimesheetDto) => ApiCallsV2.retractTimesheet(dto),
        onSuccess: () => {
            queryClient.setQueriesData<PeriodDataDto>({ queryKey: [USER_PERIOD_BY_DATE] }, old => (old ? { ...old, timesheetState: 'Open' } : old));

            useGridStore.getState().setPeriodData(prev => (prev ? { ...prev, timesheetState: 'Open' } : prev));
        },
    });
};
